import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from 'prop-types';
import { loaderSVG, ArrowBackGroup } from '../../../assets/images';
import { NO_SEARCH_CHAT_CONTACT_FOUND, REACT_APP_CONTACT_SYNC, REACT_APP_XMPP_SOCKET_HOST } from '../../processENV';
import SDK from '../../SDK';
import { Store } from '../../../store';
import { ActiveChatAction } from '../../../Actions/RecentChatActions';
import { formatGroupIdToJid } from '../../../Helpers/Chat/User';
import Contact from '../Common/Contact';
import RecentSearch from '../Common/RecentSearch';
import {
    fetchMoreParticipantsData,
    getValidSearchVal,
    handleFilterBlockedContact,
    isAppOnline,
} from '../../../Helpers/Utility';
import {
    getContactNameFromRoster,
    getUserInfoForSearch,
    getFriendsFromRosters,
    formatUserIdToJid,
} from '../../../Helpers/Chat/User';
import { NO_INTERNET } from '../../../Helpers/Constants';
import { getMaxUsersInCall } from '../../../Helpers/Call/Call';
import { getFromLocalStorageAndDecrypt } from '../WebChatEncryptDecrypt';
import userList from '../Common/userList';
import Button from '../../../ui/Button';
import logger from '../../../Helpers/logger';
import Badge from './Badge';

class NewParticipants extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            groupMembers: [],
            errorMesage: '',
            inProgress: false,
            participantToAdd: [],
            filteredContacts: [],
            displayUserNames: [],
            loaderStatus: !!props?.rosterData?.isFetchingUserList,
            userList: [],
        };
    }

    componentDidMount() {
        const { rosterData: { data = [] } = {} } = this.props;
        const friends = getFriendsFromRosters(handleFilterBlockedContact(data));
        if (!REACT_APP_CONTACT_SYNC) {
            this.setState({
                userList: friends,
                filteredContacts: friends,
                loaderStatus: this.props?.rosterData?.isFetchingUserList,
            });
        } else {
            this.setState({
                filteredContacts: friends,
            });
        }
    }

    errorMessageListner = errorMesage => {
        this.setState({
            errorMesage: errorMesage,
        });
    };

    removeParticipant = userName => {
        this.setState(prevState => ({
            errorMesage: '',
            participantToAdd: prevState.participantToAdd.filter(user => user.userId !== userName),
        }));
    };

    addParticipant = (userName, userInfo) => {
        const { participantToAdd } = this.state;
        this.setState({
            errorMesage: '',
            participantToAdd: participantToAdd.concat({
                userId: userName,
                ...userInfo,
            }),
        });
    };

    prepareContactToAdd = (userName, userInfo) => {
        if (this.props.newCall) {
            this.props.handleMakeNewCall(this.props.newCallType, [
                {
                    userId: userName,
                    ...userInfo,
                },
            ]);
            return;
        }
        const exists = this.state.participantToAdd.find(user => user.userId === userName);
        if (!exists) {
            return this.addParticipant(userName, userInfo);
        }
        return false;
    };

    prepareContactToRemove = (userName, _userInfo) => {
        const exists = this.state.participantToAdd.find(user => user.userId === userName);
        if (exists) {
            return this.removeParticipant(userName);
        }
        return false;
    };

    contactsSearch = searchTerm => {
        const { groupMembers } = this.state;
        const {
            rosterData: { data },
        } = this.props;
        if (!data) return [];
        return handleFilterBlockedContact(data)
            .filter(item => item?.userId !== this.props?.vCardData?.data?.userId)
            .filter(item => {
                const rosterJid = item.username ? item.username : item.jid;
                if (groupMembers.indexOf(rosterJid) > -1) {
                    return false;
                }

                const regexList = getUserInfoForSearch(item);
                return regexList.find(str => {
                    if (!item.isFriend || !str) return false;
                    return str.search(new RegExp(searchTerm, 'i')) !== -1;
                });
            });
    };

    searchFilterList = searchValue => {
        searchValue = getValidSearchVal(searchValue);
        let searchWith = searchValue;
        const filteredContacts = this.contactsSearch(searchWith);
        if (!REACT_APP_CONTACT_SYNC) {
            this.setState({
                errorMesage: '',
                filteredContacts: filteredContacts,
                userList: filteredContacts,
            });
            userList.getUsersListFromSDK(1, searchWith);
        } else {
            this.setState({
                errorMesage: '',
                filteredContacts: filteredContacts,
            });
        }
    };

    getBlobfromUrl = () => {
        const { groupProfileImage } = this.props;
        if (!groupProfileImage) {
            return Promise.resolve();
        }
        return fetch(groupProfileImage).then(r => r.blob());
    };

    componentDidUpdate(prevProps) {
        if (
            prevProps.messageData?.id !== this.props.messageData?.id &&
            !this.props?.messageData?.data?.MessageType &&
            this.props?.messageData?.data?.messageType === 'receiveMessage'
        ) {
            const {
                handleBackToRecentChat,
                typingMessage,
                messageData: {
                    data: { sendfrom, from: groupId, msgbody: messageBody },
                },
            } = this.props;
            const fromUser = this.props?.vCardData?.data?.fromuser;
            if (sendfrom.indexOf(fromUser) > -1 && messageBody === '2') {
                this.getBlobfromUrl()
                    .then(groupProfileImage => {
                        if (groupProfileImage === '' || groupProfileImage === null || groupProfileImage === undefined) {
                            groupProfileImage = '';
                        }
                        SDK.setGroupInfo(groupId, typingMessage, groupProfileImage, () => {
                            const { participantToAdd } = this.state;
                            participantToAdd.forEach(({ userId }) => {
                                const jid = userId + '@' + REACT_APP_XMPP_SOCKET_HOST;
                                SDK.groupAddMember(groupId, typingMessage, jid);
                            });
                            this.setState(
                                {
                                    inProgress: false,
                                },
                                () => {
                                    handleBackToRecentChat();
                                },
                            );
                        });
                    })
                    .catch(err => {
                        logger.debug(err, 'error in groupcreation');
                    });
            }
        }

        const {
            popUpData: { modalProps: { status = false, open = false } = {} },
        } = this.props;
        if (!status && !open && prevProps.rosterData && prevProps.rosterData.id !== this.props.rosterData.id) {
            let newSelectedParticipant = this.state.participantToAdd.map(ele => {
                let foundRoster = this.props.rosterData?.data?.find(el => el.userId === ele.userId);
                if (!foundRoster?.isAdminBlocked && !foundRoster?.isDeletedUser) return ele;
            });
            newSelectedParticipant = newSelectedParticipant.filter(function (element) {
                return element !== undefined;
            });
            if (!REACT_APP_CONTACT_SYNC) {
                this.setState({
                    participantToAdd: newSelectedParticipant,
                    loaderStatus: this.props?.rosterData?.isFetchingUserList,
                    filteredContacts: getFriendsFromRosters(handleFilterBlockedContact(this.props.rosterData?.data)),
                    userList: getFriendsFromRosters(handleFilterBlockedContact(this.props.rosterData?.data)),
                });
            } else {
                this.searchFilterList(this.state.searchValue);
                this.setState(prevState => ({
                    participantToAdd: newSelectedParticipant,
                    filteredContacts: this.contactsSearch(prevState.searchValue),
                }));
            }
        }
    }

    addUsersInGroup = () => {
        const { participantToAdd, inProgress } = this.state;
        if (inProgress) {
            return;
        }
        if (participantToAdd.length < 1) {
            this.setState({
                errorMesage: 'Select at least one contact',
            });
            return;
        }
        if (!isAppOnline()) {
            toast.error(NO_INTERNET);
            return;
        }

        this.setState(
            {
                inProgress: true,
            },
            async () => {
                const { typingMessage, description = '' } = this.props;
                const participantJid = [];
                participantToAdd.forEach(el => participantJid.push(el.userJid));

                const groupImgBlob = await this.getBlobfromUrl();
                const result = await SDK.createGroup(
                    typingMessage,
                    participantJid,
                    groupImgBlob || '',
                    false,
                    description,
                );

                if (result.statusCode === 200) {
                    this.setState(
                        {
                            inProgress: false,
                        },
                        async () => {
                            // If SDK returns the created group id/jid, open the conversation
                            try {
                                let groupId = null;
                                if (result.data) {
                                    groupId =
                                        result.data.groupId || result.data.groupJid || result.data.group_id || null;
                                }
                                groupId = groupId || result.groupId || result.groupJid || null;
                                if (groupId && typeof groupId === 'string' && groupId.includes('@')) {
                                    groupId = groupId.split('@')[0];
                                }
                                if (groupId) {
                                    const activeData = {
                                        chatId: groupId,
                                        chatJid: formatGroupIdToJid(groupId),
                                        recent: {
                                            chatType: 'groupchat',
                                            fromUserId: groupId,
                                        },
                                        chatType: 'groupchat',
                                        roster: {
                                            groupId: groupId,
                                            groupName: typingMessage,
                                            nickName: typingMessage,
                                            // groupImage: result.data.imageUrl || '',
                                            // thumbImage: result.data.thumbUrl || ''
                                        },
                                    };
                                    Store.dispatch(ActiveChatAction(activeData));
                                }
                            } catch (err) {
                                logger.debug('Error activating group chat after create:', err);
                            }

                            this.props.handleBackToRecentChat();
                        },
                    );
                } else {
                    logger.debug('Error creating group:', result);
                }
            },
        );
    };

    handleMakeNewCall = () => {
        const roomName = getFromLocalStorageAndDecrypt('roomName');
        if (roomName) {
            toast.info("Can't place a new call while you're already in a call.");
            return;
        }
        this.props.handleMakeNewCall(this.props.newCallType, this.state.participantToAdd);
    };

    handleUserListData() {
        let dataArr = [];
        const { searchValue, participantToAdd } = this.state;
        const { newCall = false } = this.props;
        const maxMemberReached = Boolean(participantToAdd.length >= getMaxUsersInCall() - 1);
        if (this.state.userList.length > 0) {
            this.state.userList.forEach(contact => {
                const { username, userId } = contact;
                const contactName = getContactNameFromRoster(contact);
                const updateJid = username || userId;
                const isChanged = participantToAdd.findIndex(participant => participant.userId === updateJid);
                let blockedContactArr = this.props.blockedContact.data;
                const jid = formatUserIdToJid(updateJid);
                const isBlocked = blockedContactArr.indexOf(jid) > -1;
                dataArr.push(
                    <Contact
                        isBlocked={isBlocked}
                        searchValue={searchValue}
                        contactName={contactName}
                        isChanged={isChanged}
                        maxMemberReached={!!(newCall && maxMemberReached)}
                        hideCheckbox={newCall}
                        errorMessageListner={this.errorMessageListner}
                        key={updateJid}
                        prepareContactToAdd={this.prepareContactToAdd}
                        roster={contact}
                        {...contact}
                        prepareContactToRemove={this.prepareContactToRemove}
                    />,
                );
            });
        }
        return dataArr;
    }

    fetchMoreData = () => {
        fetchMoreParticipantsData(this.state.userList, this.state.searchValue);
    };

    render() {
        const { participantToAdd, inProgress, filteredContacts, searchValue, errorMesage } = this.state;
        const { handleBackToGroup, newCall = false, handleBackToCallLog } = this.props;
        const userListArr = this.handleUserListData();
        const maxMemberReached = Boolean(participantToAdd.length >= getMaxUsersInCall() - 1);
        return (
            <div>
                <div className="contactlist">
                    <div className="recent-chatlist-header">
                        <div className="profile-img-name">
                            {!inProgress && (
                                <i
                                    className="newchat-icon"
                                    onClick={newCall ? handleBackToCallLog : handleBackToGroup}
                                    title="Back"
                                    role="button"
                                    tabIndex="0"
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            (newCall ? handleBackToCallLog : handleBackToGroup)(e);
                                        }
                                    }}
                                >
                                    <ArrowBackGroup />
                                </i>
                            )}
                            <span className="explorechannel-text sideHeaderFontWeight">
                                {newCall ? 'Contacts' : 'Add Group Participants'}
                            </span>
                        </div>
                    </div>

                    <RecentSearch placeHolder={'Search new member'} search={this.searchFilterList} />
                    {REACT_APP_CONTACT_SYNC && (
                        <ul className={`chat-list-ul newGroup ${participantToAdd.length > 0 && 'adjustHeight'}`}>
                            {filteredContacts.length === 0 && searchValue && (
                                <span className="searchErrorMsg">{NO_SEARCH_CHAT_CONTACT_FOUND}</span>
                            )}
                            {errorMesage && (
                                <div className="errorMesage">
                                    <span>{errorMesage}</span>
                                </div>
                            )}
                            <li className="chat-list-li BadgeContainer">
                                <div className="selectedBadge">
                                    <ul>
                                        {participantToAdd.map(participant => {
                                            const { userId } = participant;
                                            let blockedContactArr = this.props.blockedContact.data;
                                            const jid = formatUserIdToJid(userId);
                                            const isBlocked = blockedContactArr.indexOf(jid) > -1;
                                            return (
                                                <Badge
                                                    key={userId}
                                                    {...participant}
                                                    isBlocked={isBlocked}
                                                    removeParticipant={this.removeParticipant}
                                                />
                                            );
                                        })}
                                    </ul>
                                </div>
                            </li>

                            {filteredContacts
                                .filter(contact => contact?.userId !== this.props?.vCardData?.data?.userId)
                                .map(contact => {
                                    const { username, userId } = contact;
                                    const contactName = getContactNameFromRoster(contact);
                                    const updateJid = username || userId;
                                    const isChanged = participantToAdd.findIndex(
                                        participant => participant.userId === updateJid,
                                    );
                                    let blockedContactArr = this.props.blockedContact.data;
                                    const jid = formatUserIdToJid(updateJid);
                                    const isBlocked = blockedContactArr.indexOf(jid) > -1;
                                    return (
                                        <Contact
                                            isBlocked={isBlocked}
                                            searchValue={searchValue}
                                            contactName={contactName}
                                            isChanged={isChanged}
                                            maxMemberReached={!!(newCall && maxMemberReached)}
                                            hideCheckbox={newCall}
                                            errorMessageListner={this.errorMessageListner}
                                            prepareContactToAdd={this.prepareContactToAdd}
                                            prepareContactToRemove={this.prepareContactToRemove}
                                            key={updateJid}
                                            roster={contact}
                                            {...contact}
                                        />
                                    );
                                })}
                        </ul>
                    )}
                    {!REACT_APP_CONTACT_SYNC && (
                        <ul
                            className={`chat-list-ul newGroup ${newCall && participantToAdd.length > 0 ? 'adjustHeight' : ''}`}
                            id="scrollableUl-group"
                        >
                            <li className="chat-list-li BadgeContainer">
                                <div className="selectedBadge">
                                    <ul>
                                        {participantToAdd.map(participant => {
                                            const { userId } = participant;
                                            let blockedContactArr = this.props.blockedContact.data;
                                            const jid = formatUserIdToJid(userId);
                                            const isBlocked = blockedContactArr.indexOf(jid) > -1;
                                            return (
                                                <Badge
                                                    key={userId}
                                                    {...participant}
                                                    isBlocked={isBlocked}
                                                    removeParticipant={this.removeParticipant}
                                                />
                                            );
                                        })}
                                    </ul>
                                </div>
                            </li>
                            {this.state.loaderStatus && (
                                <div className="loader-container style-2">
                                    <img src={loaderSVG} alt="loader" />
                                </div>
                            )}
                            {filteredContacts.length === 0 && searchValue && (
                                <span className="searchErrorMsg">{NO_SEARCH_CHAT_CONTACT_FOUND}</span>
                            )}
                            {this.props.isAppOnline ? (
                                <InfiniteScroll
                                    dataLength={userListArr.length}
                                    next={this.fetchMoreData}
                                    hasMore={true}
                                    scrollableTarget="scrollableUl-group"
                                >
                                    {this.handleUserListData()}
                                </InfiniteScroll>
                            ) : (
                                this.handleUserListData()
                            )}
                        </ul>
                    )}

                    {/* {!newCall && participantToAdd.length > 0 &&
                        <div onClick={this.handleMakeNewCall} className="callButton"
                            onKeyDown={(e) => e.key === 'Enter' && this.handleMakeNewCall}
                            tabIndex="0"
                            role="button"
                        >
                            <i> {this.props.newCallType === 'video' ? <FloatingCallVideo /> : <FloatingCallAudio />}</i>{' '}
                            Call now ({participantToAdd.length})
                        </div>
                    } */}
                    {!newCall && (
                        <Button
                            variant="primary"
                            onClick={this.addUsersInGroup}
                            className={inProgress ? 'createGroup-loader' : 'createGroup-icon'}
                            title="Create group"
                            role="button"
                            tabIndex="0"
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    this.addUsersInGroup(e);
                                }
                            }}
                        >
                            {inProgress ? 'Loading' : 'Next'}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, _props) => {
    return {
        rosterData: state.rosterData,
        popUpData: state.popUpData,
        messageData: state.messageData,
        contactsWhoBlockedMe: state.contactsWhoBlockedMe,
        blockedContact: state.blockedContact,
        isAppOnline: state?.appOnlineStatus?.isOnline,
    };
};

export default connect(mapStateToProps, null)(NewParticipants);

NewParticipants.propTypes = {
    rosterData: PropTypes.object,
    popUpData: PropTypes.object,
    messageData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    contactsWhoBlockedMe: PropTypes.object,
    blockedContact: PropTypes.object,
    isAppOnline: PropTypes.bool,
    handleBackToGroup: PropTypes.func,
    handleBackToCallLog: PropTypes.func,
    handleBackToRecentChat: PropTypes.func,
    handleMakeNewCall: PropTypes.func,
    newCallType: PropTypes.string,
    newCall: PropTypes.bool,
    typingMessage: PropTypes.string,
    description: PropTypes.string,
    groupProfileImage: PropTypes.string,
    vCardData: PropTypes.shape({
        data: PropTypes.shape({
            fromuser: PropTypes.string,
        }),
    }),
};
